<template>
  <div class="py-10 md:py-16">
    <div
      ref="inner"
      class="w-full max-w-wrapper-lg px-4 xl:px-0 mx-auto"
      :class="innerClass"
    >
      <p v-if="$slots.header" class="md:text-4.5xl text-2.5xl lg:mb-12 mb-8 lg:text-center">
        <slot name="header"></slot>
      </p>

      <div
        class="grid md:grid-cols-2 md:gap-8"
        :class="{
          'gap-6': size === 'default',
          'gap-4': size === 'compact'
        }"
      >
        <div
          v-for="(item, itemKey) in items"
          :key="itemKey"
          class="bg-white shadow-sm-3 rounded-2.5xl"
          :class="{
            'py-6 px-4 md:px-10 md:pt-8 md:pb-10 flex-1': size === 'default',
            'py-4 px-6': size === 'compact'
          }"
        >
          <NuxtImg
            v-if="item?.icon"
            :src="item.icon"
            :alt="removeHtmlString(item.title)"
            :width="item?.iconDimensions?.width"
            :height="item?.iconDimensions?.height"
            :loading="imageLazyLoad ? 'lazy' : 'eager'"
            :class="{
              'mb-4 md:mb-6': size === 'default',
              'mb-4': size === 'compact'
            }"
          />

          <!-- eslint-disable vue/no-v-html -->
          <atoms-headline
            v-if="item?.title"
            class="text-lg md:text-2xl mb-4"
            tag="div"
          >
            <p v-html="item.title"></p>
          </atoms-headline>

          <div
            class="[&>p]:mb-6 [&>p:last-child]:mb-0"
            v-html="item?.description"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'MoleculesHomeInfoBlocks'
})

defineProps({
  items: {
    type: Array,
    required: true
  },

  size: {
    type: String,
    default: 'default',
    validator: value => ['default', 'compact'].includes(value)
  },

  innerClass: {
    type: String,
    default: ''
  },

  imageLazyLoad: {
    type: Boolean,
    default: false
  }
})
</script>
